import React from "react";
import { ColumnsType } from "antd/es/table";
import { TFunction } from "i18next";

import { getFormatDate } from "~/libs/getFormatDate";
import { PARTNERS_OPTIONS } from "~/pages/Partners/options";
import { applySortToColumns } from "~/shared/ui/TableV2";

export const getPartnersColumns = (
  t: TFunction,
  sortField?: string,
  sortType?: string,
  sortableColumns?: string[],
): ColumnsType<any> => {
  const columns = PARTNERS_OPTIONS.map((option) => {
    const baseColumn = {
      title: t(`partners.table.${option}`),
      dataIndex: option,
      key: option,
    };

    if (option === "createdAt" || option === "updatedAt") {
      return {
        ...baseColumn,
        render: (value: string) => (
          <span>{value ? getFormatDate(value) : "—"}</span>
        ),
      };
    }

    return {
      ...baseColumn,
      render: (value: string) => <span>{value || "—"}</span>,
    };
  });

  return applySortToColumns(columns, sortField, sortType, sortableColumns);
};
